<template>
<div v-if="amazingOffers != null && amazingOffers.length > 0" class="specials-product-swiper" style="background-color: #1399b6;">
	<section class="specials-product-swiper-container">
        <div class="specials-product-swiper-title">
            <img src="../../../public/assets/img/amazing/Amazings.svg" />
            <img src="../../../public/assets/img/amazing/box.png" />
        </div>
	    <div class="widget widget-product card" v-if="amazingOffers != '' && amazingOffers != null">
        <div id="" class="product-amazing   owl-carousel owl-theme">
            <div :style='{"height" : "auto"}' class="item  discount-box" v-for="(product,index) in amazingOffers">
                <div :class="!product.IsAvailable ? 'filter' : '' ">
                    <router-link :title="product.ProductName"
                                 :to="getProductLink(product)">
                        <img :src="product.PicPath"
                             class="img-fluid"
                             :alt="product.AltPicPath"
                             :title="product.ProductName"
                             @error="imageLoadOnError">
                    </router-link>

                    <h2 class="post-title">
                        <router-link tag="a"
                                     :title="product.ProductName"
                                     :to="getProductLink(product)">
                            {{ product.ProductName }}
                        </router-link>
                    </h2>
                    <div>
                        <div class="price">
                            <div v-if="!product.IsAvailable">
                                <span class="unAvailable">ناموجود</span>
                            </div>
                            <!-- ناموجود -->
                        </div>
                        <!--<div class="wi-div-in">
                            <i v-if="product.IsAvailable" @click="AddItemWithProductId(product.ProductId)" class="incress-wi now-ui-icons ui-1_simple-add "></i>
                        </div>-->
                    </div>

                </div>
            </div>

        </div>
    </div>
	</section>
</div>
</template>

<script>
    import { setCart } from "../../module/cart";
    export default {
        computed: {
             amazingOffers: function () {
                return this.$store.getters.readAmazingOffers;
            },
            customerGroupId: function () {
                return this.$store.getters.readCustomerGroupId;
            } 
        },
        beforeMount() {
            this.isUserLogined = IsNullOrEmptyString(localStorage.getItem('accessToken')) ? false : true;
        },
        methods: {
            getProductLink(product) {
                const baseName =
                    product.RedirectLink && product.RedirectLink.trim() !== ''
                        ? product.RedirectLink
                        : product.Name;

                const cleanedName = baseName
                    .replace(/\//g, '-')
                    .replace(/\*/g, '-')
                    .replace(/\s+/g, '-');

                return {
                    name: 'product',
                    params: {
                        productId: product.Id,
                        productName: cleanedName
                    }
                };
            },
            imageLoadOnError(event) {
                event.target.src = "/assets/img/no-image-available.png";
            },
            AddItemWithProductId(productId) {
                setCart(this, productId, 'AddItemWithProductId', '.loader', null, 1);
            },
        }
    }
</script>

<style scoped>
    .discount {
        position: absolute;
        padding: 4px 6px 1px;
        left:10px;
        background-color: #fb3449;
        color: #fff;
        border-radius: 20px;
        letter-spacing: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
    }
    .widget, .brand-slider {
        background: unset;
        padding: 1px;
    }
    .card {
        box-shadow: unset;
    }
    .widget-product .product-amazing .owl-item {
        border: unset;
    }
    .widget-product .product-amazing .item,
    .widget-product .product-carousel .item,
    .brand-slider .owl-carousel .item {
        background: #fff;
        border-radius: 10px;
        height: 420px;
    }
    .specials-product-swiper {
        margin-bottom:15px;
    }
    .specials-product-swiper-title img {
        width: 100%;
        max-height: calc(100% - 41px);
        -o-object-fit: contain;
        object-fit: contain;
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
    }
    .specials-product-swiper .specials-product-swiper-container {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: stretch;
        -ms-flex-align: stretch;
        align-items: stretch;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
        padding: 35px 15px;
        background-size: auto;
        background-size: auto 100%;
        min-height: 350px;
     
    }
    .specials-product-swiper a {
        box-shadow: none !important;
    }

    .specials-product-swiper-title {
        margin: 0 44px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: start;
        -ms-flex-align: start;
        align-items: flex-start;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        width: 170px;
    }

    .widget-product .product-amazing .item .post-title {
        min-height: 35px;
        height:auto;
        max-height:unset;
    }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .unAvailable::after {
            top: 13px;
            left: 0px;
        }
        .discount {
            position: absolute;
            padding: 4px 6px 1px;
            left: 10px;
            bottom: 110px;
            font-size: 14px;
        }
        .specials-product-swiper-title[data-v-b7c23bc6] {
            margin: 0 10px;
        }
            .unAvailable::before {
            top: 13px;
            right: 0;
        }
        .unAvailable {
            font-size: 13px;
        }
    }


</style>